import { Apple } from "lucide-react";
import { BRAND } from "../../data/content";

export const StoreButtons = ({ className = "" }) => (
  <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
    <a
      href={BRAND.appStoreUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="appstore-btn"
      className="group inline-flex items-center gap-3 rounded-full px-5 py-3 bg-ink text-white transition-[transform,background-color] duration-300 will-change-transform hover:-translate-y-0.5 hover:bg-[#1e293b]"
      aria-label="Download WhatThe? Scan on the App Store"
    >
      <Apple className="h-5 w-5" strokeWidth={1.6} />
      <span className="text-left leading-none">
        <span className="block text-[10px] uppercase tracking-[0.16em] opacity-70">
          Download on the
        </span>
        <span className="block text-sm font-semibold">App Store</span>
      </span>
    </a>
  </div>
);
